export default (array, sep = ',') =>
  Array.isArray(array) ? array.join(sep) : array
